import Vue from 'vue';
import Vuex from 'vuex';
import appState from "./store/state";
import appMutations from "./store/mutations";
import appActions from "./store/actions";
import appGetters from "./store/getters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: appState,
  mutations: appMutations,
  actions: appActions,
  getters: appGetters
});
